import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { useNavigate } from "react-router-dom"; // Importa el hook useNavigate
import { BasicModal } from "../../../Shared";
import { AssistanceForm } from "../AssistanceForm";
import { useAuth } from "../../../../hooks";
import { AssistanceApi } from "../../../../api";
import "./AssistanceItem.scss";

const assistanceController = new AssistanceApi();

export function AssistanceItem(props) {
  const { assistance, onReload } = props;
  const { accessToken } = useAuth();
  const navigate = useNavigate(); // Utiliza useNavigate para la navegación

  const [showModal, setShowModal] = useState(false);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const [showConfirm, setShowConfirm] = useState(false);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onDelete = async () => {
    try {
      await assistanceController.deleteAssistance(accessToken, assistance._id);
      console.log("Assistance deleted", assistance._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };
  const openAssistanceIdpUBLIC = () => {
    try {
      navigate(`/assistancechatpublic/${assistance._id}`); // Navega a la página Assistance con el ID en la URL
    } catch (error) {
      console.log(error);
    }
  };
  const openAssistanceId2d = () => {
    try {
      navigate(`/assistanceChat/${assistance._id}`); // Navega a la página Assistance con el ID en la URL
    } catch (error) {
      console.log(error);
    }
  };
  const openAssistanceId3d = () => {
    try {
      navigate(`/assistanceChat3d/${assistance._id}`); // Navega a la página Assistance con el ID en la URL
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="assistance-item">
        <div className="assistance-item__info">
          <Image src={`${assistance.miniature}`} />
          <div>
            <span className="assistance-item__info-title">
              {assistance.title}
            </span>
            <span className="assistance-item__info-path">
              {assistance.path}
            </span>
          </div>
        </div>
        <div>
          <Button icon onClick={openAssistanceId3d} target="_blank">
            3D
          </Button>
          <Button icon onClick={openAssistanceId2d} target="_blank">
            2D
          </Button>
          <Button icon onClick={openAssistanceIdpUBLIC} target="_blank">
            PUBLIC
          </Button>
          <Button icon primary onClick={onOpenCloseModal}>
            <Icon name="pencil" />
          </Button>
          <Button icon color="red" onClick={onOpenCloseConfirm}>
            <Icon name="trash" />
          </Button>
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Editar Assistance"
        size="small"
      >
        <AssistanceForm
          assistance={assistance}
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`Estas seguro de eliminar el assistance ${assistance.title}`}
        size="mini"
      />
    </>
  );
}
